export function getFirstName(name: string | undefined): string {
  if (!name) return "";
  const parts = name.trim().split(/\s+/);
  return parts.length > 0 ? parts[0] : "";
}
